import React, { useState } from 'react';

import { Box } from '@clutter/clean';

import { NavLinkButton, Badge, Panel, Table } from '@shared/components/bootstrap';
import { Pagination } from '@shared/components/pagination';

import { Permission } from '@admin/components/helpers/permission';
import { useTitle } from '@admin/hooks/use_title';
import { MARKETING } from '@admin/libraries/access_control_catalog.generated';
import { client } from '@admin/libraries/apollo';
import { usePaginatedRedirectsQuery } from '@admin/schema';

import { RedirectDestroyButton } from './redirect_destroy_button';

export const RedirectList: React.FC = () => {
  useTitle('Marketing Dashboard');
  const [page, setPage] = useState(1);
  const { data, refetch } = usePaginatedRedirectsQuery({
    client,
    variables: {
      page,
    },
  });

  return (
    <Panel>
      <Panel.Body>
        <Table striped responsive>
          <thead>
            <tr>
              <th className="text-left">ID</th>
              <th className="text-left">Slugs</th>
              <th className="text-left">Redirect URL</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data?.paginated.results.map((redirect) => (
              <tr key={redirect.id}>
                <td className="text-left">{redirect.id}</td>
                <td className="text-left">
                  <Box.Flex gap="4px" flexWrap="wrap">
                    {redirect.slugs.map((slug) => (
                      <Badge key={slug} style="info">
                        {slug}
                      </Badge>
                    ))}
                  </Box.Flex>
                </td>
                <td className="text-left">{redirect.targetURL}</td>
                <td>
                  <Permission resource={MARKETING.resource} action={MARKETING.actions.update} denied={null}>
                    <Box.Flex gap="4px" justifyContent="flex-end">
                      <RedirectDestroyButton redirect={redirect} onDelete={refetch} />
                      <NavLinkButton to={`/marketing/redirects/${redirect.id}/edit`} kind="primary">
                        Edit
                      </NavLinkButton>
                    </Box.Flex>
                  </Permission>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {data?.paginated.pagination && <Pagination pagination={data.paginated.pagination} onPage={setPage} />}
      </Panel.Body>
      <Permission resource={MARKETING.resource} action={MARKETING.actions.update} denied={null}>
        <Panel.Footer>
          <Box.Flex gap="4px" justifyContent="flex-end">
            <NavLinkButton to="/marketing/redirects/new" kind="primary">
              New
            </NavLinkButton>
          </Box.Flex>
        </Panel.Footer>
      </Permission>
    </Panel>
  );
};
